import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./Home";
import Other_details from "./Other_details";

const Approut=()=>{
    return<BrowserRouter>
    <Switch>
        <Route path="/" component={Home} exact/>
        <Route path="/Other_details" component={Other_details} exact/>
        
    </Switch>
    </BrowserRouter>
}

export default Approut;